import React, { useContext, useMemo } from 'react';
import { noop } from 'underscore';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { TextAssetCollectionWithRecommendations } from './text-asset-collection-with-recommendations';
import { getTextAssetCollectionConfig } from './config/text-asset-collection-config';

export const DescriptionAssetCollection = React.memo((props) => {
  const {
    data,
    onChange,
    updateSuggestionMeasurement,
    setApplyDescriptionsCallback,
  } = props;
  const i18n = useContext(I18nContext);
  const headlineConfig = useMemo(() => getTextAssetCollectionConfig('descriptions'), []);

  return (
    <div className="description-asset-collection">
      <TextAssetCollectionWithRecommendations
        {...headlineConfig}
        i18n={i18n}
        data={data}
        onChange={onChange}
        updateSuggestionMeasurement={updateSuggestionMeasurement}
        withInlineRecommendations
        setApplyTextAssetCallback={setApplyDescriptionsCallback}
      />
    </div>);
});

DescriptionAssetCollection.propTypes = {
  data: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  updateSuggestionMeasurement: PropTypes.func.isRequired,
  setApplyDescriptionsCallback: PropTypes.func,
};

DescriptionAssetCollection.defaultProps = {
  setApplyDescriptionsCallback: noop,
};

